// @ts-expect-error module not typed
import { isEmailCMF } from 'conversations-message-history/common-message-format/operators/cmfComparators';
// @ts-expect-error module not typed
import { getIsMemberOfForwardedSubthread } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { LAST_NON_FWD_MESSAGE } from 'conversations-message-history/constants/messagePositionDescriptors';
export const shouldMessageAllowReplies = (message, positionDescriptors) => {
  const isForwarded = isEmailCMF(message) && getIsMemberOfForwardedSubthread(message);
  return isForwarded || positionDescriptors.has(LAST_NON_FWD_MESSAGE);
};